<script setup lang="ts">
  import type { HTMLAttributes } from 'vue'
  import { cn } from '@gat-ship/vue-components'
  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class']
      iconClass?: HTMLAttributes['class']
      /** The email to display. */
      email?: string
      /** The text to display when there is no email. @default 'No Email.' */
      noEmailText?: string

      /** Whether to show the email icon. @default false */
      showIcon?: boolean
      testId?: string
      dataTestId?: string
    }>(),
    {
      showIcon: true
    }
  )
</script>
<template>
  <a
    v-if="email"
    @click.stop
    :href="`mailto:${email}`"
    :class="cn('hover:text-link/80 flex items-center gap-2', props.class)"
  >
    <gat-icon
      v-if="props.showIcon"
      icon="Mail"
      :class="cn('size-4', props.iconClass)"
    />
    <span :data-testid="props.testId ?? props.dataTestId">{{ email }}</span>
  </a>
  <span v-else class="text-soft">{{ noEmailText ?? 'No Email.' }}</span>
</template>
